import BaseTransform from "@/transforms/modules/base-transform";

export default {

    transformCities(cities) {
        let vm = this;
        let result = [];
        if (cities && cities.length > 0) {
            cities.forEach(function (city) {
                result.push(vm.transformCityItem(city))
            })
        }
        return result;
    },

    transformCityItem(city) {
        return {
            id: BaseTransform.transformNumeric(city, 'id'),
            title: BaseTransform.transformString(city, 'title'),
        }
    },

    transformDistricts(districts) {
        let vm = this;
        let result = [];
        if (districts && districts.length > 0) {
            districts.forEach(function (district) {
                result.push(vm.transformDistrictItem(district))
            })
        }
        return result;
    },

    transformDistrictItem(district) {
        return {
            id: BaseTransform.transformNumeric(district, 'id'),
            prefix: BaseTransform.transformString(district, 'prefix'),
            title: BaseTransform.transformString(district, 'title'),
            title_full: BaseTransform.transformString(district, 'title_full'),
        }
    },

    transformWards(wards) {
        let vm = this;
        let result = [];
        if (wards && wards.length > 0) {
            wards.forEach(function (ward) {
                result.push(vm.transformWardItem(ward))
            })
        }
        return result;
    },

    transformWardItem(ward) {
        return {
            id: BaseTransform.transformNumeric(ward, 'id'),
            prefix: BaseTransform.transformString(ward, 'prefix'),
            title: BaseTransform.transformString(ward, 'title'),
            title_full: BaseTransform.transformString(ward, 'title_full'),
        };
    }
}
